import { createRouter, createWebHistory, RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import { employeesRoutes } from '@/router/employees'
import { sessionRoutes } from '@/router/session'
import { useSessionModule } from '@/modules/session'
import { MembersRouteNames, SessionRouteNames } from '@/router/routes-names'
import { organizationsRoutes } from '@/router/organizations'
import { packagesRoutes } from '@/router/packages'
import { agreementsRoutes } from '@/router/agreements'
import { membersRoutes } from '@/router/members'
import { jobTitlesRoutes } from '@/router/job-titles'
import { industriesRoutes } from '@/router/industries'
import { freeFormsRoutes } from '@/router/free-forms'
import { freeSubscriptionsRoutes } from '@/router/free-subscriptions'
import { authenticationLogsRoutes } from '@/router/authentication-logs'
import { failedLoginAttemptsRoutes } from '@/router/failed-login-attempts'
import { whitelistedIpsRoutes } from '@/router/whitelisted-ips'
import { electronicOperatorsRoutes } from '@/router/electronic-operators'
import { invoicesRoutes } from '@/router/invoices'
import { ssoJoinRules } from '@/router/sso-join-rules'
import { auditLogsRoutes } from '@/router/audit-logs'
import jwtDecode, { JwtPayload } from 'jwt-decode'

const routes: Array<RouteRecordRaw> = [
    ...employeesRoutes,
    ...sessionRoutes,
    ...organizationsRoutes,
    ...packagesRoutes,
    ...agreementsRoutes,
    ...membersRoutes,
    ...jobTitlesRoutes,
    ...freeFormsRoutes,
    ...freeSubscriptionsRoutes,
    ...authenticationLogsRoutes,
    ...failedLoginAttemptsRoutes,
    ...whitelistedIpsRoutes,
    ...electronicOperatorsRoutes,
    ...invoicesRoutes,
    ...ssoJoinRules,
    ...auditLogsRoutes,
    ...industriesRoutes
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const { isLoggedIn } = useSessionModule()

    if (isLoggedIn.value && (typeof localStorage.token !== 'undefined')) {
        const jwtToken = jwtDecode<JwtPayload>(localStorage.token)
        const expTime = jwtToken.exp || 0
        if (expTime < (Date.now() / 1000)) {
            useSessionModule().logOut()
            next({ name: SessionRouteNames.LOGIN })
            return
        }
    }

    if (from.name === SessionRouteNames.LOGIN && !isLoggedIn.value) {
        next(from)
        return
    }

    if (isLoggedIn.value && to.name === SessionRouteNames.LOGIN) {
        next(from)
        return
    }

    if (!isLoggedIn.value && to.name !== SessionRouteNames.LOGIN) {
        const nextRoute = {
            name: to.name,
            query: { ...to.query },
            params: { ...to.params }
        }
        window.localStorage.setItem('nextRoute', JSON.stringify(nextRoute))
        next({ name: SessionRouteNames.LOGIN })
    } else if (isLoggedIn.value && to.path === '/') {
        next({ name: MembersRouteNames.LIST, query: { page: '1' } })
    } else {
        next()
    }
})

export default router
